<div class="dashboard-container">
    <h1 class="dashboard-header">Dashboard</h1>
    <div class="dashboard-wrapper">
         <iframe
        class="draxlr"
        src="https://app.draxlr.com/public/dashboard/AIBhjersmSXK7QsxRuOevgRVkkvHB9ur?pin=338534"
    >
    </iframe>
    </div>
</div>